import React from 'react';
import { AnchorProps } from '@sls-react/components/Links/A';
import { Link } from '@sls-react/routing';

type Props = AnchorProps;

const MyPurchasesLink: React.FC<Props> = ({ children, ...props }) => (
  <Link href="/purchases" passHref>
    <a {...props}>{children}</a>
  </Link>
);

export default MyPurchasesLink;
